import naics_raw from './naics_codes.csv'

var rev_codes = {}
naics_raw.forEach( c =>{
  rev_codes[c.CODE]=c.NAME
})

var codes = {}
Object.keys(rev_codes).forEach( (k)=>{
  codes[rev_codes[k].toLowerCase()]=k
})

export default{
  codes,
  rev_codes
}



//////////////////
// WEBPACK FOOTER
// ./src/assets/mecs_naics.js
// module id = null
// module chunks = 